



















import { Component, Prop } from 'vue-property-decorator';
import { getFastInquiryIM, getIM } from '@/constant';
import Webview from '../../webview';

let timer: NodeJS.Timeout;
@Component
export default class PayConfirm extends Webview {
  created() {
    this.adapter.hideNavBar();
  }

  handleNext(): boolean {
    const { consultId, bizId: channel, checkingType, doctorId } = this.$route.query;
    if (this.env.inAPP && checkingType) {
      window.Sailer.checkingType({
        ...this.$route.query
      });
      return false;
    }

    if (consultId) {
      // TODO 后边 adapter 集成原生和H5跳转页面 需替换
      if (this.env.inAPP) {
        this.adapter.replace('native://page-quick-consult-entrance');
        return false;
      }
      this.adapter.replace(getFastInquiryIM(Number(consultId), Number(channel)));
      return false;
    }

    if (this.env.inAPP) {
      this.adapter.replace(`native://page-customer-service-im:${JSON.stringify({ toId: doctorId })}`);
      return false;
    }
    // this.adapter.goIM({ toId: doctorId.toString() });
    this.adapter.replace(getIM(doctorId as string));
    return true;
  }
}
